<script lang="ts">
	import map_has from 'shared/map_has'

	type Pistol = {
		make: TrexPistolMake[`name`]
		family: TrexPistolFamily[`name`]
		model: TrexPistolModel[`name`]
		light: TrexPistolLight[`name`]
		url_path: string
	}

	export let supported_pistols: Pistol[]

	const make_map = supported_pistols.reduce((make_map, pistol) => {
		if (map_has(make_map, pistol.make)) {
			const family_map = make_map.get(pistol.make)
			if (map_has(family_map, pistol.family)) {
				const model_map = family_map.get(pistol.family)
				if (map_has(model_map, pistol.model)) {
					model_map.get(pistol.model).push(pistol)
				} else {
					model_map.set(pistol.model, [ pistol ])
				}
			} else {
				family_map.set(pistol.family, new Map([ [ pistol.model, [ pistol ] ] ]))
			}
		} else {
			make_map.set(pistol.make, new Map([ [ pistol.family, new Map([ [ pistol.model, [ pistol ] ] ]) ] ]))
		}
		return make_map
	}, new Map<string, Map<string, Map<string, Pistol[]>>>)
</script>

<div class=container>
	{#each Array.from(make_map.entries()) as [ make, family_map ]}
		<h1>Supported { make } Pistols</h1>
		<ul>
			{#each Array.from(family_map.entries()) as [ family, model_map ]}
				{#each Array.from(model_map.entries()) as [ model, pistols ]}
					<li>
						{ family.startsWith(make) ? `` : make } { model.startsWith(family) ? `` : family } { model }
						<span class=lights>
							[
							{#each pistols as { light, url_path }, i}
								<a href={ url_path }>{ light }</a>{#if i < pistols.length - 1 }{ `, ` }{/if}
							{/each}
							]
						<span>
					</li>
				{/each}
			{/each}
		</ul>
	{/each}
</div>

<style>
	.container {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
	li {
		list-style: none;
		margin-left: 0;
		font-size: 15px;
	}
	@media (max-width: 600px) {
		li {
			display: flex;
			flex-direction: column;
		}
		.lights {
			padding-left: 1rem;
		}
	}
</style>
